import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import AttendeePdfAccessModal from './AttendeePdfAccessModal';

const TriggerButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
`;

const AttendeePdfLink = ({ pdfGroups, eventCode, linkText = '', className = '', id = '' }) => {
    const [showModal, setShowModal] = useState(false);
    const isSplit = pdfGroups.some(g => g.heading !== null);
    const defaultText = isSplit ? 'Attendee Lists (pdf)' : 'Attendee List (pdf)';

    return (
        <>
            <TriggerButton className={className} id={id} onClick={() => setShowModal(true)}>
                {linkText || defaultText}
            </TriggerButton>

            {showModal &&
                ReactDOM.createPortal(
                    <AttendeePdfAccessModal
                        onClose={() => setShowModal(false)}
                        eventCode={eventCode}
                        pdfGroups={pdfGroups}
                    />,
                    document.body
                )}
        </>
    );
};

AttendeePdfLink.propTypes = {
    pdfGroups: PropTypes.arrayOf(
        PropTypes.shape({
            heading: PropTypes.string,
            pdfs: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string,
                    displayLabel: PropTypes.string,
                })
            ).isRequired,
        })
    ).isRequired,
    eventCode: PropTypes.string.isRequired,
    linkText: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string,
};


export default AttendeePdfLink;
